<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1 14V3C1 2.44772 1.44772 2 2 2H6C6.31476 2 6.61115 2.14819 6.8 2.4L7.7 3.6C7.88885 3.85181 8.18524 4 8.5 4H13C13.5523 4 14 4.44772 14 5V7M1 14H13L14.6358 8.27472C14.8183 7.63591 14.3386 7 13.6743 7H4.20472C3.78211 7 3.40512 7.26567 3.26298 7.66366L1 14Z"
        stroke="var(--icon-color)" stroke-width="2" stroke-linejoin="round" />
</svg>
